/**
 * User: Shad
 * Date: 11/12/13
 */

"use strict";

var root = typeof window === 'undefined' ? global : window;
var SoaModel = require('bunsen/models/SoaModel');
var assign = require('lodash.assign');

/**
 * @class UserProfile
 * @extends SoaModel
 */
var UserProfile = module.exports = SoaModel.extend();

var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var currency = require('bunsen/libraries/currency');
var SoaModelLabelAndValueTransformer = require('bunsen/models/SoaModelLabelAndValueTransformer');
var User = require('bunsen/models/identity/User');

root.bunsen.UserProfile = UserProfile;

_.extend(UserProfile.prototype, SoaModelLabelAndValueTransformer, {
    url: function () {
        // TODO: find a better way to get the user ID
        return endpoints.userProfile(this.parents[0].id);
    },
    displayLabels: {
        email: 'Primary Email',
        email2: 'Secondary Email',
        phoneNumber: '1stdibs Display Telephone',
        directPhoneNumber: 'Telephone',
        line1: 'Address 1',
        line2: 'Address 2',
        zipCode: 'ZIP',
        decorator: 'Design Professional',
        companyName: 'Company',
        companyDescription: 'Business Description',
        association: 'Trade Association (TA)',
        associationId: 'TA Member Number',
        associationPhone: 'TA Telephone Number',
        currency: 'Preferred Currency'
    },
    //Overwriting Backbone isNew in order for save to know whether it should use POST or PUT
    isNew: function () {
        var user = User.getCurrentUser();
        return user ? user.isNew() : UserProfile.__super__.isNew.call(this);
    },
    displayTransforms: {
        resaleState: function (val) {
            return (val === "-1") ? 'Non-US' : val;
        },
        associationPhone: SoaModelLabelAndValueTransformer.defaultDisplayTransforms.phoneNumber,
        currency: function (val) {
            var currencyObj = currency(val);
            return (currencyObj) ? currencyObj.name : val;
        }
    },
    /**
     * Get standard formatted display name for a user based on their profile.
     * @param  {Object} [options]
     * @param  {boolean} [options.defaultToEmail] - return user's email username if no first/last name
     * @returns {string}
     */
    getDisplayName: function (options) {
        var first = this.get('firstName') || '';
        var last = this.get('lastName') || '';
        var email = this.get('email') || '';
        options = assign({
            defaultToEmail: true
        }, options);
        if (first || last) {
            return (first + ' ' + last).trim();
        } else if (email && options.defaultToEmail) {
            return email.split('@')[0].split('.').join(' ');
        }
        return '';
    },
    // breaks displayName up by whitespace. Sets firstName to first part, and lastName to remaining parts joined by spaces
    setDisplayName: function (displayName) {
        var nameParts = displayName.split(/[\s]+/);
        return this.set({
            firstName: nameParts[0],
            lastName: nameParts.slice(1).join(' ')
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/UserProfile.js
// module id = 1206
// module chunks = 62